module.exports = __webpack_public_path__ + "img/bi_spinner_before.b60e95ec.svg";